import { useQuery } from "@tanstack/react-query";
import Table from "../common/Table";
import Button from "../common/Button";
import { partnerService } from "../../services/partners";

const ProspectList = ({ filters, onEdit, onDelete, onConvert }) => {
  const { data: prospects, isLoading } = useQuery({
    queryKey: ["partner-prospects", filters],
    queryFn: () => partnerService.getProspects(filters),
  });

  const columns = [
    { header: "Name", accessor: "name" },
    { header: "Company", accessor: (row) => row.company || "-" },
    { header: "Website", accessor: (row) => row.website ? (
      <a href={row.website.startsWith("http") ? row.website : `https://${row.website}`} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline text-xs">{row.website}</a>
    ) : "-" },
    { header: "Contacted Via", accessor: (row) => {
      const labels = { linkedin: "LinkedIn", website: "Website", whatsapp: "WhatsApp", email: "Email", cold_call: "Cold Call", referral: "Referral", instagram: "Instagram", facebook: "Facebook", twitter: "Twitter", other: "Other" };
      return labels[row.contactedVia] || row.contactedVia || "-";
    }},
    { header: "Designation", accessor: (row) => row.designation || "-" },
    { header: "Industry", accessor: (row) => row.industry || "-" },
    { header: "City", accessor: (row) => row.city || "-" },
    { header: "Status", accessor: (row) => {
      const colors = { new: "bg-blue-100 text-blue-700", contacted: "bg-yellow-100 text-yellow-700", interested: "bg-green-100 text-green-700", negotiating: "bg-purple-100 text-purple-700", converted: "bg-emerald-100 text-emerald-700", lost: "bg-red-100 text-red-700" };
      return <span className={`px-2 py-1 rounded-full text-xs font-medium ${colors[row.status] || "bg-gray-100 text-gray-700"}`}>{row.status}</span>;
    }},
  ];

  const actions = (row) => (
    <div className="flex gap-2 justify-end">
      {row.status !== "converted" && onConvert && (
        <Button size="sm" variant="success" onClick={() => onConvert(row)}>Convert</Button>
      )}
      {onEdit && <Button size="sm" onClick={() => onEdit(row)}>Edit</Button>}
      {onDelete && <Button size="sm" variant="danger" onClick={() => onDelete(row._id)}>Delete</Button>}
    </div>
  );

  if (isLoading) return <div>Loading...</div>;

  return <Table columns={columns} data={prospects} actions={actions} />;
};

export default ProspectList;
